import React, { ReactElement, useEffect } from 'react'

import { FAQ } from '@mindfulchefuk/components/FAQ/FAQ'
import { MultiCardGroup } from '@mindfulchefuk/features/CMS/components'
import { NextPageWithLayout } from '@mindfulchefuk/types/NextJS'
import MainLayout from '@mindfulchefuk/layouts/MainLayout'
import { FAQOnboardingCopy } from '@mindfulchefuk/features/Onboarding/constants/FAQ.copy'
import { howItWorks } from '@mindfulchefuk/features/Homepage/data/multi-card-groups'
import { Box } from '@mindfulchefuk/design-system'
import { trackAnalyticsEvent } from '@mindfulchefuk/utils/analytics/amplitude/amplitudeAdapter'

const HowItWorksPage: NextPageWithLayout = (): ReactElement => {
  useEffect(() => {
    trackAnalyticsEvent({
      name: 'how it works viewed',
    })
  }, [])
  return (
    <Box overflow="hidden">
      <MultiCardGroup data={howItWorks} ctaLocation="how it works page" />
      <FAQ questions={FAQOnboardingCopy} />
    </Box>
  )
}

HowItWorksPage.getLayout = (page) => {
  return <MainLayout title="How it works">{page}</MainLayout>
}

export default HowItWorksPage

export { getStaticGlobalContent as getStaticProps } from '@mindfulchefuk/features/CMS/services/getStaticData'
